// extracted by mini-css-extract-plugin
export default {"hotkeyInfo":"HotkeyInfo-module__hotkeyInfo--mytWs","animatedBackground":"HotkeyInfo-module__animatedBackground--YAWlv"};